import { login, getUserInfo, logout } from '@/api/auth'

const user = {
  state: {
    name: '',
    type: '', // system: 管理员  business: 店铺
    menus: []
  },

  mutations: {
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },

    SET_NAME: (state, name) => {
      state.name = name
    },

    SET_TYPE: (state, type) => {
      const map = {
        SYSTEM: 'system',
        SHOP: 'business'
      }

      state.type = map[type]
      localStorage.adminType = map[type]
    },

    SET_AUTH: () => {
      localStorage.login = 'success'
    },

    REMOVE_AUTH: () => {
      localStorage.login = ''
    }
  },

  actions: {
    adminLogin({ commit }, userInfo) {
      const username = userInfo.username.trim()

      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then((res) => {
            commit('SET_AUTH')
            resolve(res.result)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token)
          .then((response) => {
            const { data } = response

            commit('SET_TYPE', data.type)
            commit('SET_NAME', data.userName)
            commit('SET_SHOP_ID', data.shopId)
            commit('SET_MENUS', data.menus.length ? data.menus : [null])

            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    logout({ commit }) {
      return new Promise((resolve) => {
        logout().then(() => {
          commit('REMOVE_AUTH')
          resolve()
        })
      })
    }
  }
}

export default user
